module.exports = __webpack_public_path__ + "static/media/phone_2.09ad3ca2.png";